import type { RouteObject as AdminRouteObject } from "react-router-dom";
import type { AdminDashboardDependencies } from "../composition/create-admin-dashboard-dependencies";
import { UserDataDetailScreen } from "../../features/users/user-data-detail-screen";

export function createUserDetailRoute(dependencies: AdminDashboardDependencies): AdminRouteObject {
  return {
    path: "users/:internalUserId",
    element: <UserDataDetailScreen dependencies={dependencies} />,
  };
}
